import React, { useCallback } from "react";
import { useProviderHelpers } from "./ProviderHelpers";

const Context = React.createContext();

export const ContractProvider = ({ children }) => {
  const { data, execute, clearData } = useProviderHelpers();
  const listRecords = useCallback(async () => {
    await execute({
      scope: "list",
      url: "Contract/GetContracts",
      method: "GET",
      secure: true,
    });
  }, [execute]);

  const selectRecord = useCallback(
    async (props) => {
      await execute({
        scope: "select",
        url: `Contract/${props.contractId}`,
        method: "GET",
        secure: true,
      });
    },
    [execute]
  );

  const contractsData = useCallback(async () => {
    await execute({
      scope: "selectDropdownContractsData",
      url: `Contract/GetContractsData`,
      method: "GET",
      secure: true,
    });
  }, [execute]);

  const deleteRecord = useCallback(
    async (props) => {
      await execute({
        scope: "delete",
        url: `Contract/DeleteContract/${props.contractId}`,
        method: "POST",
        payload: props,
        secure: true,
      });
    },
    [execute]
  );

  const newRecord = useCallback(
    async (props) => {
      await execute({ scope: "new", payload: { status: 200, body: props } });
    },
    [execute]
  );

  const createRecord = useCallback(
    async (props) => {
      await execute({
        scope: "create",
        url: `Contract/CreateContract`,
        method: "POST",
        payload: props,
        secure: true,
      });
    },
    [execute]
  );

  const updateRecord = useCallback(
    async (props) => {
      await execute({
        scope: "edit",
        url: `Contract/EditContract`,
        method: "POST",
        payload: props,
        secure: true,
      });
    },
    [execute]
  );
  const listUsersRecords = useCallback(async () => {
    await execute({
      scope: "usersList",
      url: `Contract/ActiveUsersByFranchise`,
      method: "GET",
      secure: true,
    });
  }, [execute]);

  const value = {
    listRecords,
    contractsData,
    selectRecord,
    newRecord,
    createRecord,
    updateRecord,
    deleteRecord,
    listUsersRecords,
    data,
    clearData,
  };

  return <Context.Provider value={value}>{children}</Context.Provider>;
};

export const useContractStore = () => React.useContext(Context);
